// Columnas de la vista tabla de clientes. Las celdas las pinta CompactClientCard
// (layout="row") según la `key`, para reutilizar sus acciones y modales.
export const getClientTableColumns = ({
  showAgency = false,
  showArchivedDate = false,
  showPack = true,
} = {}) => [
  { key: "client", header: "Cliente", minWidth: 340 },
  { key: "pack", header: "Pack", hidden: !showPack },
  { key: "agency", header: "Agencia", hidden: !showAgency },
  { key: "consultants", header: "Consultores", minWidth: 180 },
  { key: "setup", header: "Setup", tooltip: "Estado y progreso del setup técnico", minWidth: 160 },
  showArchivedDate
    ? { key: "archived", header: "Baja", tooltip: "Fecha en la que se archivó el cliente" }
    : { key: "created", header: "Alta", tooltip: "Fecha de alta del cliente" },
  { key: "actions", header: "Acciones" },
  { key: "platform", header: "Plataforma", tooltip: "Setup técnico, conversación principal y equipo" },
  { key: "external", header: "Enlaces", tooltip: "Web, Drive, NotebookLM, Clientify y TodoList" },
];
